export const AT_BLOCKER_SET =           'OPEN_BOARDS_DIALOG_BLOCKER_SET';
export const AT_INITIAL_STATE_SET =     'OPEN_BOARDS_DIALOG_INITIAL_STATE_SET';
export const AT_OPENED_SET =            'OPEN_BOARDS_DIALOG_OPENED_SET';
export const AT_CURRENT_BOARD_ID_SET =  'OPEN_BOARDS_DIALOG_CURRENT_BOARD_ID_SET';
export const AT_TAB_LOAD_STATUS_SET =   'OPEN_BOARDS_DIALOG_TAB_LOAD_STATUS_SET';
